import { render } from "./SharePoint_ResultDetails.vue?vue&type=template&id=f08c94e4&scoped=true"
import script from "./SharePoint_ResultDetails.vue?vue&type=script&lang=js"
export * from "./SharePoint_ResultDetails.vue?vue&type=script&lang=js"

import "./SharePoint_ResultDetails.vue?vue&type=style&index=0&id=f08c94e4&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f08c94e4"]])

export default __exports__